__turbopack_context__.v({
  "button": "iu0Cgq_button",
  "disabled": "iu0Cgq_disabled",
  "quantity": "iu0Cgq_quantity",
  "root": "iu0Cgq_root",
  "sizeLarge": "iu0Cgq_sizeLarge",
  "sizeSmall": "iu0Cgq_sizeSmall",
  "v_banners": "iu0Cgq_v_banners",
  "v_neutral": "iu0Cgq_v_neutral",
  "v_neutralOutline": "iu0Cgq_v_neutralOutline",
  "v_neutralText": "iu0Cgq_v_neutralText",
  "v_primary": "iu0Cgq_v_primary",
  "v_primaryOutline": "iu0Cgq_v_primaryOutline",
  "v_primaryText": "iu0Cgq_v_primaryText",
  "v_secondary": "iu0Cgq_v_secondary",
  "v_secondaryOutline": "iu0Cgq_v_secondaryOutline",
  "v_secondaryText": "iu0Cgq_v_secondaryText",
  "v_tertiary": "iu0Cgq_v_tertiary",
  "v_tertiaryOutline": "iu0Cgq_v_tertiaryOutline",
  "v_tertiaryText": "iu0Cgq_v_tertiaryText",
  "v_textInherit": "iu0Cgq_v_textInherit",
  "v_white": "iu0Cgq_v_white",
  "v_whiteOutline": "iu0Cgq_v_whiteOutline",
  "v_whiteText": "iu0Cgq_v_whiteText",
});
